import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const InputsText = ({ state, type, className, frameClassName, focusClassName, text = "Placeholder", value, onChange, name }) => {
  return (
    <div className={`inputs-text ${className}`}>
      {["default", "disable", "focus", "typing"].includes(state) && (
        <div className={`frame-2 state-${state} ${type} ${frameClassName}`}>
          {type === "text" && (
            <input
              type="text"
              className={`placeholder ${focusClassName}`}
              placeholder={text}
              disabled={state === "disable"}
              value={value}
              onChange={(e) => onChange(name ,e.target.value, type)}
            />
          )}

          {type === "password" && (
            <>
              <input
                type="password"
                className="password-2"
                placeholder={state === "default" ? "Password" : ""}
                disabled={state === "disable"}
                value={value}
                onChange={(e) => onChange(name ,e.target.value, type)}
              />
              <div className="eye-no">
                <img className="icon" alt="Icon" src="https://c.animaapp.com/AP7s1SnC/img/icon-2.svg" />
              </div>
            </>
          )}
        </div>
      )}

      {state === "error" && (
        <>
          <div className="div-wrapper">
            <div className="text-wrapper-3">Error</div>
          </div>
          <div className="text-wrapper-4">Error message is here.</div>
        </>
      )}
    </div>
  );
};

InputsText.propTypes = {
  state: PropTypes.oneOf(["default", "focus", "disable", "typing", "error"]),
  type: PropTypes.oneOf(["text", "password"]),
  text: PropTypes.string,
};